import { Typography } from "@circle-react-shared/uikit/Typography";
import { useContentSpecAccessDetails } from "@circle-react/hooks/accessRegistry/useContentSpecAccessDetails";
import type { ContentSpecType } from "@circle-react/types/AccessRegistry";
import { contentSpecTypes } from "@circle-react/types/AccessRegistry";

import { t } from "@/i18n-js/instance";

import { ContentSpecAccessGroups } from "./ContentSpecAccessGroups";

export interface ContentSpecAccessGroupsControlProps {
  contentSpecId: number;
  contentSpecType: ContentSpecType;
}

const i18nRoot =
  "settings.access_registry.components.content_spec_access_groups_control";

export const ContentSpecAccessGroupsControl = ({
  contentSpecType,
  contentSpecId,
}: ContentSpecAccessGroupsControlProps) => {
  const { data, isInitialLoading: isLoading } = useContentSpecAccessDetails(
    contentSpecType,
    contentSpecId,
  );

  if (isLoading || !data || data.type === contentSpecTypes.AccessGroup) {
    return null;
  }

  return (
    <>
      <Typography.BodyMd>{t([i18nRoot, "warning"])}</Typography.BodyMd>
      <ContentSpecAccessGroups contentSpecAccessDetails={data} />
    </>
  );
};
